import React from "react";
import { Container, Row, Col } from "reactstrap";
import DemoNavbar from "components/Navbars/DemoNavbar.jsx";
import CardsFooter from "components/Footers/CardsFooter";
import ChildPageBanner from "./layout/ChildPageBanner";
import StackedTitle from "./layout/StackedTitle";

const banner = {
  background: "/banner/investment.png",
  Title: "INVESTMENT",
  childTitle: "PRIVATE CAPITAL &<br/>STRUCTURED GROWTH",
  desktopCol: "8",
};

const titleGroups = [
  [
    { text: "PRIVATE CAPITAL" },
    { text: "SOLUTION &"},
    { text: "GLOBAL", tone: "accent" },
    { text: "INVESTMENT", tone: "accent" },
  ]
];

const intro = {
  title:
    "CONNECTING CAPITAL WITH TRANSFORMATIVE OPPORTUNITIES ACROSS INFRASTRUCTURE, TECHNOLOGY AND HIGH-GROWTH MARKETS",
  paragraphs: [
    "HMG’s Strategic Investments division connects private capital with scalable businesses, strategic assets, and complex cross-border projects.",
    "Through investment origination, transaction structuring, project finance, mergers and acquisitions, and strategic partnerships, we help transform high-potential opportunities into commercially viable, institutionally aligned investments.",
    "With established networks across Asia, the United States, and key international markets, HMG works with family offices, private investors, project developers, operating companies, and strategic partners to advance opportunities across infrastructure, technology, energy, real estate, healthcare, consumer markets, and sustainable development.",
    "Depending on the opportunity, HMG participates as a strategic investor, development partner, transaction facilitator, or cross-border market partner.",
  ],
};

const focusAreas = [
  { title: "PRIVATE CAPITAL & FAMILY OFFICE INVESTMENTS", image: "/content/private-capital-1.png" },
  { title: "AI, TECHNOLOGY & ADVANCED ENGINEERING", image: "/content/private-capital-2.png" },
  { title: "HEALTHCARE, LIFE SCIENCES & WELLNESS", image: "/content/private-capital-3.png" },
  { title: "CONSUMER, HOSPITALITY & LIFESTYLE", image: "/content/private-capital-4.png" },
  { title: "ENERGY & STRATEGIC INFRASTRUCTURE", image: "/content/private-capital-5.png" },
  { title: "REAL ESTATE PROPERTY & DESTINATION DEVELOPMENT", image: "/content/private-capital-6.png" },
  { title: "SUSTAINABLE & IMPACT-LED GROWTH", image: "/content/private-capital-7.png" },
  { title: "HERITAGE & CULTURAL ASSETS", image: "/content/private-capital-8.png" },
];

const capabilities = [
  "Project & Asset-Backed Financing",
  "Private Equity & Co-Investment",
  "Structured Equity, Debt & Mezzanine Capital",
  "Mergers, Acquisitions & Strategic Transactions",
  "Cross-Border Investment Structuring",
  "Capital Introduction & Transaction Coordination",
  "Strategic Partnerships & Joint Ventures",
  "Pre-IPO, IPO & Capital Markets Readiness",
  "Growth Capital & International Market Expansion",
];

const strategicAdvantage = [
  "By combining sector intelligence, sophisticated investment structuring, proprietary project access, and an established international partner network, HMG connects capital with high-value opportunities across Asia and key global markets.",
  "HMG’s investment platform is designed to advance institutional growth and create enduring value across infrastructure, energy, next-generation technology, healthcare, real estate, and global consumer markets.",
];

class PrivateCapital extends React.Component {
  constructor() {
    super();
    this.state = {
      width: window.innerWidth,
    };
  }

  componentWillMount() {
    window.addEventListener("resize", this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const isMobile = this.state.width <= 500;
    const style = isMobile ? "pt-sm section-components" : "section section-components";

    return (
      <>
        <DemoNavbar />
        <main className="investment investment-private-capital-page">
          <ChildPageBanner banner={banner} />
          <section className={style}>
            <Container>
              <section className="section-nucleo-icons">
                <Row className="align-items-top row-grid">
                  <Col md="5">
                    <StackedTitle groups={titleGroups} />
                  </Col>
                  <Col md="7">
                    <h1 className="home-child-title-body">{intro.title}</h1>
                    {intro.paragraphs.map(paragraph => (
                      <p className="description-Normal" key={paragraph.slice(0, 40)}>
                        {paragraph}
                      </p>
                    ))}
                  </Col>
                </Row>
              </section>
            </Container>

            <Container className="mt-5 investment-body-container">
              <section className="investment-focus-section">
                <h2>INVESTMENT FOCUS AREAS</h2>
                <div className="investment-focus-grid">
                  {focusAreas.map(({ title, image }) => (
                    <article
                      className="investment-focus-tile"
                      data-focus-image={image}
                      data-image-pending={image ? "false" : "true"}
                      key={title}
                      style={image ? { backgroundImage: `url(${image})` } : undefined}
                    >
                      <div className="investment-focus-tile-content">
                        <h3>{title}</h3>
                      </div>
                    </article>
                  ))}
                </div>
              </section>
            </Container>

            {/* Same container and column span as the intro row above, so this
                block lines up with the right-hand copy column. */}
            <Container className="mt-md">
              <section className="section-nucleo-icons">
                <Row>
                  <Col md={{ size: 7, offset: 5 }}>
                    <h2 className="home-child-title-body">
                      FINANCING &amp; TRANSACTION CAPABILITIES
                    </h2>
                    <div className="mt-4 description-Normal">
                      <ul>
                        {capabilities.map(item => (
                          <li key={item}>{item}</li>
                        ))}
                      </ul>
                    </div>
                    <h2 className="mt-5 home-child-title-body">STRATEGIC ADVANTAGE</h2>
                    {strategicAdvantage.map(paragraph => (
                      <p className="description-Normal" key={paragraph.slice(0, 40)}>
                        {paragraph}
                      </p>
                    ))}
                  </Col>
                </Row>
              </section>
            </Container>
          </section>
        </main>
        <CardsFooter />
      </>
    );
  }
}

export default PrivateCapital;
